module.exports = __webpack_public_path__ + "img/calendar_cropped_scaled.72bbf249.png";